// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard/LeadDashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Leads from "layouts/leads";
import Activity from "layouts/activity";
// @mui icons
import Icon from "@mui/material/Icon";
import ActivityDashboard from "layouts/dashboard/ActivityDashboard";
import TaskIcon from "@mui/icons-material/Task";
import Ocf from "layouts/ocf";
import Otf from "layouts/ocf/Otf";
import RevenueReports from "layouts/RevenueReport/RevenueReports";

import Assignment from "layouts/Assignment/index";
import PullBack from "layouts/pullback/index";
const routes = [
  {
    type: "collapse",
    name: "Lead Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    view: true,
  },
  {
    type: "collapse",
    name: "Activity Dashboard",
    key: "activity-dashboard",
    icon: <TaskIcon fontSize="small" />,
    route: "/activity-dashboard",
    component: <ActivityDashboard />,
    view: true,
  },

  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "OTF",
  //   key: "otf",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/otf",
  //   component: <Otf />,
  //   view: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Revenue Report",
  //   key: "revenue-report",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/revenue-report",
  //   component: <RevenueReports />,
  //   view: true,
  // },

  // {
  //   type: "collapse",
  //   name: "Assignment",
  //   key: "assignment",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/assignment",
  //   component: <Assignment />,
  //   view: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Pull Back",
  //   key: "pull-back",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/pull-back",
  //   component: <PullBack />,
  //   view: true,
  // },

  {
    type: "collapse",
    name: "Call Report",
    key: "call-report",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/call-report",
    component: <Tables />,
    view: true,
    // children: [
    //   {
    //     key: "call-report",
    //     name: "Call Report",
    //     route: "/tables/call-report",
    //     component: <Tables />,
    //   },
    //   {
    //     key: "attendance-report",
    //     name: "Attendance Report",
    //     route: "/tables/attendance-report",
    //     component: <Tables />,
    //   },
    // ],
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    view: true,
  },
  {
    type: "collapse",
    name: "Leads",
    key: "lead",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/dashboard/leads",
    component: <Leads />,
    view: false,
  },
  {
    type: "collapse",
    name: "Leads",
    key: "activity",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/dashboard/activity",
    component: <Activity />,
    view: false,
  },
  {
    type: "collapse",
    name: "OCF Form",
    key: "ocf-form",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/otf-form/:id",
    component: <Ocf />,
    view: false,
  },
];

export default routes;
